import React from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { BreadcrumbProps, Button, Heading, Icon } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../Localization'
import { DashboardsDataTable } from './components/DashboardsDataTable'
import { useHistory } from 'react-router-dom'

export const DashboardsPage = () => {
  const L = useLocalizedStrings()
  const history = useHistory()

  const pageActionButtons = [
    <Button 
      size="sm"
      onClick={() => {
        history.push('/admin-panel/my-dashboards/dashboard-builder')
      }}
      icon={<Icon
        name="PlusIcon"
        type="solid"
        role="decorative"
      />}
    >
      Create New
    </Button>
  ]

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: 'Dashboards'
    }
  ]

  return (
    <AdminPanelPage
      title={L.admin_panel.dashboards.dashboards} 
      pageActionButtons={pageActionButtons}
      breadcrumbs={breadcrumbs}
    >
      <DashboardsDataTable />
    </AdminPanelPage>
  )
}